//https://developers.google.com/analytics/devguides/collection/ga4/reference/events#remove_from_cart
class RemoveFromCartEventListener {
    // Language: javascript
    // Path: RemoveFromCartEventListener.js
    // Compare this snippet from EventListener.js:

    get AllCartRemoveTag() {
        return ".gtm-view-cart";
    }
    get AllCartRemoveQuantitiesTag() {
        return ".gtm-view-cart .number-unit input";
    }
    get AllCartRemoveSelector() {
        return "gtm-remove-from-allcart";
    }
    get SingleProductQunatityTag() {
        return "[name='addToCartAmount']";
    }
    get DefaultEventName() {
        return "click";
    }

    constructor(element, eventName = this.DefaultEventName) {
        this.element = element;
        this.eventName = eventName;
    }

    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();

        function AllCartRemove() {
            var cartItems = document.querySelectorAll(
                RemoveFromCartEventListener.prototype.AllCartRemoveTag
            );
            var quantites =
                document.querySelectorAll(
                    RemoveFromCartEventListener.prototype
                        .AllCartRemoveQuantitiesTag
                ).length > 0
                    ? document.querySelectorAll(
                          RemoveFromCartEventListener.prototype
                              .AllCartRemoveQuantitiesTag
                      )
                    : document.querySelectorAll(
                          ".cart-body__quantity-control-input"
                      );

            var totalPrice;
            var items = [];
            var currency;

            for (var i = 0; i < cartItems.length; i++) {
                var cartItem = cartItems[i];
                var analyticsData = cartItem.dataset.analytics
                    ? JSON.parse(cartItem.dataset.analytics)
                    : null;

                if (analyticsData && cartItem.dataset) {
                    var analticsDataProducts = analyticsData.products
                        ? analyticsData.products[0]
                        : null;
                    var quantity = parseFloat(quantites[i].value);
                    totalPrice = cartItem.dataset.total;
                    currency = cartItem.dataset.cartcurrency;

                    var price = Number(
                        analticsDataProducts.price
                            ? analticsDataProducts.price.replace(",", ".")
                            : cartItem.dataset.price.replace(",", ".")
                    ).toFixed(2);
                    var pricewithdiscount = Number(
                        analticsDataProducts.pricewithdiscount
                            ? analticsDataProducts.pricewithdiscount.replace(
                                  ",",
                                  "."
                              )
                            : cartItem.dataset.priceWithDiscount.replace(
                                  ",",
                                  "."
                              )
                    ).toFixed(2);
                    var item = {
                        item_id: analticsDataProducts.code,
                        item_name: analticsDataProducts.name,
                        currency: analticsDataProducts.currency,
                        item_brand: analticsDataProducts.brand,
                        item_category: analticsDataProducts.category,
                        price: pricewithdiscount,
                        quantity: quantity,
                    };

                    if (analticsDataProducts.categories) {
                        var splitCategories =
                            analticsDataProducts.categories.split(";");
                        for (var j = 0; j < splitCategories.length; j++) {
                            if (j == 0) {
                                item["item_category"] = splitCategories[j];
                            } else {
                                item["item_category" + j] = splitCategories[j];
                            }
                        }
                    }

                    if (price != pricewithdiscount) {
                        item["price"] = analticsDataProducts.price;
                        item["discount"] = (price - pricewithdiscount).toFixed(
                            2
                        );
                    }

                    items.push(item);
                }
            }

            if (items.length > 0) {
                SendData(dataLayer);
            }
            function SendData(dataLayer) {
                dataLayer
                    .push({
                        event: "remove_from_cart",
                        ecommerce: {
                            currency: currency,
                            value: totalPrice,
                            items: items,
                        },
                    })
                    .then(() => {
                        console.log("GTM pushed remove_from_cart event");
                        setTimeout(() => {
                            var instanceActivate = new ActivateGtm();
                            instanceActivate.activateRemoveFromCart();
                        }, 2000);
                    })
                    .catch((error) => {
                        console.warn("GTM error remove_from_cart event", error);
                    });

                if (typeof gtag !== "undefined" && !!gtag) {
                    gtag("event", "remove_from_cart", {
                        event_category: "Enhanced Ecommerce",
                        event_label: "Remove from cart",
                        value: totalPrice,
                        currency: currency,
                        items: items,
                    });
                }
            }
        }

        function SingleProductRemove(that) {
            var analyticsData = that.dataset.analytics
                ? JSON.parse(that.dataset.analytics)
                : null;

            if (analyticsData && that.dataset) {
                var analticsDataProducts = analyticsData.products
                    ? analyticsData.products[0]
                    : null;
                var addToCartAmount = $(that)
                    .parent()
                    .find(that.SingleProductQunatityTag);
                var quantity = parseFloat($(addToCartAmount).val());

                var price = Number(
                    analticsDataProducts.price
                        ? analticsDataProducts.price.replace(",", ".")
                        : that.dataset.price.replace(",", ".")
                ).toFixed(2);
                var pricewithdiscount = Number(
                    analticsDataProducts.pricewithdiscount
                        ? analticsDataProducts.pricewithdiscount.replace(
                              ",",
                              "."
                          )
                        : that.dataset.priceWithDiscount.replace(",", ".")
                ).toFixed(2);

                var item = {
                    item_id: analticsDataProducts.code,
                    item_name: analticsDataProducts.name,
                    currency: analticsDataProducts.currency,
                    item_brand: analticsDataProducts.brand,
                    item_category: analticsDataProducts.category,
                    price: pricewithdiscount,
                    quantity: quantity ? quantity : that.dataset.quantity,
                };
                if (analticsDataProducts.categories) {
                    var splitCategories =
                        analticsDataProducts.categories.split(";");
                    for (var i = 0; i < splitCategories.length; i++) {
                        if (i == 0) {
                            item["item_category"] = splitCategories[i];
                        } else {
                            item["item_category" + i] = splitCategories[i];
                        }
                    }
                }

                if (that.dataset.variant) {
                    var variant = JSON.parse(that.dataset.variant);
                    if (variant) {
                        item["item_variant"] = Object.values(variant).join(",");
                    }
                }

                if (price != pricewithdiscount) {
                    item["price"] = analticsDataProducts.price;
                    item["discount"] = (price - pricewithdiscount).toFixed(2);
                }

                dataLayer
                    .push({
                        // eslint-disable-line
                        event: "remove_from_cart",
                        ecommerce: {
                            currency: analticsDataProducts.currency,
                            value: (pricewithdiscount * item.quantity).toFixed(
                                2
                            ),
                            items: [item],
                        },
                    })
                    .then(() => {
                        console.log("GTM pushed remove_from_cart event");
                        setTimeout(() => {
                            var instanceActivate = new ActivateGtm();
                            instanceActivate.activateRemoveFromCart();
                        }, 1000);
                    })
                    .catch((error) => {
                        console.warn("GTM error remove_from_cart event", error);
                    });

                if (typeof gtag !== "undefined" && !!gtag) {
                    gtag("event", "remove_from_cart", {
                        event_category: "Enhanced Ecommerce",
                        event_label: "Remove from cart",
                        value: (pricewithdiscount * item.quantity).toFixed(2),
                        currency: analticsDataProducts.currency,
                        items: [item],
                    });
                }
            }
        }

        if (
            this.element &&
            this.element.className.includes(
                RemoveFromCartEventListener.prototype.AllCartRemoveSelector
            )
        ) {
            AllCartRemove();
        } else if (
            this.className.includes(
                RemoveFromCartEventListener.prototype.AllCartRemoveSelector
            )
        ) {
            AllCartRemove();
        } else {
            SingleProductRemove(this);
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            RemoveFromCartEventListener.prototype.callback
        );
    }

    remove() {
        this.element.removeEventListener(
            this.eventName,
            RemoveFromCartEventListener.prototype.callback
        );
    }
}
